/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaBepozProductSummaryCtrl
 * @description A report that replicates the Product summary from the Bepoz back office
 */
angular.module('mercury.modules.qa.wizbang')
.controller('QaWizbangOrdersCtrl', ["$filter", "reporttime", "$q", "$scope", "$http", "$stateParams", "title", "userinfo", "settings", function($filter, reporttime, $q, $scope, $http, $stateParams, title, userinfo, settings) {
  title.set('Orders (Staff) Report');

  $scope.companyName = userinfo.companyName();

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaWizbangOrdersStaff', {
    params: {startTime: reporttime.start(), endTime: reporttime.end()}}
  );

  $scope.reportLines = [];
  $scope.totalUnits = 0;
  $scope.totalValue = 0;

  var updateTotals = function(object, item) {

    object.totalUnits += item.nettQty;
    object.totalValue += item.nett;

  };

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);

    // First we place the lines in a heirachy, then flatten it to make the lines in the table
    var remoteLocations = {};
    angular.forEach(response.data.lines, function(item) {
      if (!item.remoteLocationId) {
        item.remoteLocationId = -1;
        item.remoteLocationName = '';
      }

      if (!item.outletId) {
        item.outletId = -1;
        item.outletName = '';
      }

      // Group into remote locations
      if (!remoteLocations[item.remoteLocationId]) {
        remoteLocations[item.remoteLocationId] = {
          remoteLocationName: item.remoteLocationName,
          remoteLocationId: item.remoteLocationId,
          outlets: {},
          totalUnits: 0,
          totalValue: 0
        };
      }

      if (!remoteLocations[item.remoteLocationId].outlets[item.outletId]) {
        remoteLocations[item.remoteLocationId].outlets[item.outletId] = {
          outletName: item.outletName,
          outletId: item.outletId,
          staffMembers: {},
          totalUnits: 0,
          totalValue: 0
        };
      }

      if (!remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId]) {
        remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId] = {
          staffName: item.staffName,
          staffId: item.staffId,
          forb: {},
          totalUnits: 0,
          totalValue: 0
        };
      }

      if (!remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb]) {
        remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb] = {
          forb: item.forb,
          itemGroups: {},
          totalUnits: 0,
          totalValue: 0
        };
      }

      if (!remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb].itemGroups[item.itemGroupId]) {
        remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb].itemGroups[item.itemGroupId] = {
          itemGroupAbbrev: item.itemGroupAbbrev,
          itemGroupId: item.itemGroupId,
          items: [],
          totalUnits: 0,
          totalValue: 0
        };
      }

      if (!remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb].itemGroups[item.itemGroupId]) {
        remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb].itemGroups[item.itemGroupId] = {
          itemGroupAbbrev: item.itemGroupAbbrev,
          itemGroupId: item.itemGroupId,
          items: {},
          totalUnits: 0,
          totalValue: 0
        };
      }

      // finally! the item
      remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb].itemGroups[item.itemGroupId].items.push({
        isItemLine: true,
        isValueLine: true,
        forb: item.forb,
        itemId: item.itemId,
        itemGroupAbbrev: item.itemGroupAbbrev,
        itemAbbrev: item.itemAbbrev,
        itemOrder: item.itemOrder,
        units: item.nettQty,
        value: item.nett
      });

      updateTotals(remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb].itemGroups[item.itemGroupId], item);
      updateTotals(remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId].forb[item.forb], item);
      updateTotals(remoteLocations[item.remoteLocationId].outlets[item.outletId].staffMembers[item.staffId], item);
      updateTotals(remoteLocations[item.remoteLocationId].outlets[item.outletId], item);
      updateTotals(remoteLocations[item.remoteLocationId], item);
      updateTotals($scope, item);
    });

    angular.forEach(remoteLocations, function(remoteLocation) {
      if (remoteLocations.length > 1) {
        $scope.reportLines.push({
          isHeader: true,
          headerText: remoteLocation.remoteLocationName + ' - ' + $scope.companyName
        });
      }

      angular.forEach(remoteLocation.outlets, function(outlet) {
        if (remoteLocation.outlets.length > 1) {
          $scope.reportLines.push({
            isHeader: true,
            headerText: outlet.outletName
          });
        }

        angular.forEach(outlet.staffMembers, function(staffMember) {
          $scope.reportLines.push({
            isHeader: true,
            headerText: staffMember.staffName
          });

          angular.forEach(staffMember.forb, function(forb) {
            // TODO: make sure that the groups are ordered alphabetically
            angular.forEach(forb.itemGroups, function(group) {
              angular.forEach(group.items, function(item) {
                $scope.reportLines.push(item);
              });

              // Item Group subtotal
              $scope.reportLines.push({
                isFooter: true,
                isValueLine: true,
                footerText: 'Subtotals for ' + group.itemGroupAbbrev,
                units: group.totalUnits,
                value: group.totalValue
              });
            });

            // Item ForB subtotal
            $scope.reportLines.push({
              isFooter: true,
              isValueLine: true,
              footerText: (forb.forb == 'F' ? 'Food' : 'Beverage') + ' Subtotals for ' + staffMember.staffName,
              units: forb.totalUnits,
              value: forb.totalValue
            });
          });

          // Staff Member subtotal
          $scope.reportLines.push({
            isFooter: true,
            isValueLine: true,
            footerText: 'Subtotals for ' + staffMember.staffName,
            units: staffMember.totalUnits,
            value: staffMember.totalValue
          });
        });

        // Outlet Subtotals
        if (remoteLocation.outlets.length > 1) {
          $scope.reportLines.push({
            isFooter: true,
            isValueLine: true,
            footerText: 'ORDER TOTALS FOR ' + outlet.outletName,
            units: outlet.totalUnits,
            value: outlet.totalValue
          });
        }
      });

      // Remote location totals
      if (remoteLocation.outlets.length > 1) {
        $scope.reportLines.push({
          isFooter: true,
          isValueLine: true,
          footerText: 'ORDER TOTALS FOR ' + remoteLocation.remoteLocationName,
          units: remoteLocation.totalUnits,
          value: remoteLocation.totalValue
        });
      }
    });
  });
}]);
